export const FETCH_COLLECTIONS_REQUEST = 'collection/FETCH_COLLECTIONS_REQUEST';
export const FETCH_COLLECTIONS_SUCCESS = 'collection/FETCH_COLLECTIONS_SUCCESS';
export const FETCH_COLLECTIONS_FAILURE = 'collection/FETCH_COLLECTIONS_FAILURE';

export const FETCH_COLLECTION_DETAIL_REQUEST = 'collection/FETCH_COLLECTION_DETAIL_REQUEST';
export const FETCH_COLLECTION_DETAIL_SUCCESS = 'collection/FETCH_COLLECTION_DETAIL_SUCCESS';
export const FETCH_COLLECTION_DETAIL_FAILURE = 'collection/FETCH_COLLECTION_DETAIL_FAILURE';

export const CLEAR_COLLECTION_DETAIL = 'collection/CLEAR_COLLECTION_DETAIL';
